import { Button } from "@ui";
import style from "./Tariff.module.scss";
import cn from "classnames";
import { CountrySelect, OperatorSelect, QuantityInput, TermSelect } from "./components";
import { useState } from "react";
import { ITariff } from "@interfaces/user/tariff";
import { EOperator } from "@interfaces/operator.enum";
import { useBuyProxyMutation } from "@RTKQuery/user/purchases/purchases";
import { useNavigate } from "react-router-dom";

const tariffsStaticData = {
    "Silver": {
        color: "#AAB3D3",
        list: [
            "Швидкість з'єднання до 30 мб/сек",
            "Безлімітний трафік",
            "Зміна  ip кожні 15 хвилин",
            "До 4-х користувачів",
            "SOCKS5/HTTP",
            "Підключення до проксі без VPN"
        ]
    },
    "Platinum": {
        color: "#C6B164",
        list: [
            "Швидкість з'єднання до 50 мб/сек",
            "Безлімітний трафік",
            "Приватний канал",
            "Зміна IP за посиланням/за часом",
            "SOCKS5/HTTP",
            "Підключення до проксі без VPN"
        ]
    },
    "Brilliant": {
        color: "#1E9EEE",
        list: [
            "Швидкість з'єднання до 100 мб/сек",
            "Безлімітний трафік",
            "Приватний канал",
            "Зміна IP за посиланням/за часом",
            "SOCKS5/HTTP",
            "Підключення до проксі без VPN"
        ]
    },
}

export function Tariff({
    tariffsDynamicData
}: {
    tariffsDynamicData: ITariff
}) {
    const [buyProxy, { isSuccess, isLoading, error, reset }] = useBuyProxyMutation();

    const navigate = useNavigate()

    const [selectData, setSelectData] = useState({
        tariff_name: tariffsDynamicData.name,
        modems_quantity: 1,
        days: tariffsDynamicData.rental_periods.find(item => item.rent_time === 30)?.rent_time || 0,
        operator: tariffsDynamicData.free_proxies[0] || {},
        pay_sum: tariffsDynamicData.rental_periods.find(item => item.rent_time === 30)?.price || 0
    });

    return (
        <div className={style.tariff}>
            <div className="flex justify-between items-center pl-[30px] mb-[30px]">
                <p className={style.price}>
                    ${selectData.pay_sum * selectData.modems_quantity}
                </p>
                <div className={cn(style.type, `bg-[${tariffsStaticData[tariffsDynamicData.name].color}]`)}>
                    {tariffsDynamicData.name}
                </div>
            </div>
            <div className="flex flex-col gap-[10px] px-[20px] mb-[30px]">
                {
                    tariffsStaticData[tariffsDynamicData.name].list.map((item, i) => (
                        <div key={i} className={style.point}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                                <path d="M7.5 0.5C3.35786 0.5 0 3.85786 0 8C0 12.1421 3.35786 15.5 7.5 15.5C11.6421 15.5 15 12.1421 15 8C14.9952 3.85986 11.6401 0.504822 7.5 0.5Z" fill="#1E9EEE" fillOpacity="0.15" />
                                <path d="M11.8286 5.62521L7.55052 11.4308C7.44849 11.5662 7.29635 11.6549 7.12828 11.677C6.96022 11.6991 6.79032 11.6527 6.65677 11.5483L3.60177 9.10584C3.33218 8.8901 3.28853 8.49667 3.50427 8.22709C3.72 7.9575 4.11343 7.91385 4.38302 8.12959L6.93052 10.1677L10.8224 4.88584C10.95 4.69433 11.1726 4.58845 11.4017 4.61024C11.6308 4.63202 11.8293 4.77794 11.9186 4.99007C12.0078 5.2022 11.9733 5.4462 11.8286 5.62521Z" fill="#1E9EEE" />
                            </svg>
                            <p>{item}</p>
                        </div>
                    ))
                }
            </div>
            <div className="flex flex-col gap-[15px] px-[20px] mb-[40px]">
                <CountrySelect />
                <div className="flex gap-[9px]">
                    <QuantityInput
                        value={selectData.modems_quantity}
                        setValue={(quantity) => {
                            setSelectData(state => ({
                                ...state,
                                modems_quantity: quantity
                            }))
                        }}
                    />
                    <TermSelect
                        value={selectData.days}
                        listTerms={[...tariffsDynamicData.rental_periods].sort((a, b) => a.rent_time - b.rent_time)}
                        setValue={(term) => {
                            setSelectData(state => ({
                                ...state,
                                days: term.rent_time,
                                pay_sum: term.price
                            }))
                        }}
                    />
                </div>
                <OperatorSelect
                    value={selectData.operator}
                    dataList={tariffsDynamicData.free_proxies}
                    setValue={(operator) => {
                        setSelectData(state => ({
                            ...state,
                            operator,
                            modems_quantity: 1
                        }))
                    }}
                />
            </div>
            <div className="px-[20px] ">
                <Button
                    text="Придбати проксі"
                    customStyle={{
                        width: "!w-full",
                        button: "!h-[42px] !w-full",
                        text: "!text-[15px]"
                    }}
                    onClick={() => {
                        buyProxy({
                            days: selectData.days,
                            modems_quantity: selectData.modems_quantity,
                            operator: selectData.operator.operator,
                            tariff_name: selectData.tariff_name
                        })
                    }}
                    loading={isLoading}
                    successContent={
                        isSuccess
                            ? {
                                title: "Вітаємо!",
                                description: <p className="max-w-[260px]"><span className="font-bold">Ви успішно придбали тариф {tariffsDynamicData.name}.</span> Приємного користування!</p>,
                                button: {
                                    text: "Перейти в мої проксі",
                                    action: () => {
                                        reset();
                                        navigate("/");
                                    }
                                }
                            }
                            : undefined
                    }
                    errors={[
                        (error && ((extractError) => {
                            const err = extractError(error)

                            return err === "Not enough money on the balance sheet" ? {
                                title: "От халепа!",
                                description: <p className="max-w-[360px]"><span className="font-bold">На вашому обліковому записі недостатньо коштів.</span> Будь ласка, поповніть свій баланс, щоб придбати пакет послуг.</p>,
                                button: {
                                    text: "Поповнити баланс",
                                    action: () => {
                                        reset();
                                        navigate("/balance?tab=replenish");
                                    }
                                }
                            } : err
                        }))
                    ]}
                    resetStatus={() => {
                        reset();
                    }}
                />
            </div>
        </div>
    )
}